import { render, staticRenderFns } from "./type45.vue?vue&type=template&id=3c53c1a0&scoped=true"
import script from "./type45.vue?vue&type=script&lang=js"
export * from "./type45.vue?vue&type=script&lang=js"
import style0 from "./type45.vue?vue&type=style&index=0&id=3c53c1a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c53c1a0",
  null
  
)

export default component.exports